import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  @Input()
  badge : string;

  @Input() 
  ctaLabel : string;

  constructor() { }

  ngOnInit(): void {
  }

}
